(function() {
'use strict';

angular
    .module('dashboard')
    .controller('ContactDetail', ContactDetail);

function ContactDetail($routeParams, $rootScope, $location, $q, dashboardBookingService, deliveryAddressService, resourceService, mybTrack) {
    const cm = this;
    cm.updateDeliveryAddressWithlLeadContact = true;
    cm.bookingId = $routeParams.bookingId ? parseInt($routeParams.bookingId) : 0;
    cm.user = $rootScope.user;
    cm.isContactSaved = false;
    cm.bookingType = dashboardBookingService.getBookingTypeMap();
    cm.cancelContactChange = cancelContactChange;

    mybTrack.track('MYB - Open Contact Details');

    cm.updateContactDetails = function() {
        const putContact = dashboardBookingService.putContact(cm.bookingId, cm.ContactDetails, cm.updateRelatedBooking);
        const putDeliveryAddress = cm.requireDeliverAddress ? deliveryAddressService.put(cm.bookingId, cm.updateDeliveryAddressWithlLeadContact ? cm.ContactDetails : cm.DeliveryAddress) : null;

        $q.all([putContact, putDeliveryAddress]).then(function() {
            cm.isContactSaved = true;
        }, function() {
            $rootScope.$broadcast('flash:error', resourceService.get('CONTACTSAVEDERROR'));
            cm.isContactSaved = false;
        });
    };

    dashboardBookingService.getContact(cm.bookingId).then(function(contactDetail) {
        cm.ContactDetails = contactDetail.data;
    });

    function _processDeliveryAddress(bookingType) {
        if (bookingType === cm.bookingType.attraction) {
            //Require delivery address only for attractions
            cm.requireDeliverAddress = true;

            deliveryAddressService.get(cm.bookingId).then(function(deliveryAddress) {
                cm.DeliveryAddress = deliveryAddress.data;
                //Setting this to true, only if on load, delivery address is matched with contact address.
                cm.updateDeliveryAddressWithlLeadContact = _.isMatch(cm.ContactDetails, cm.DeliveryAddress);
            });
        }
    }

    dashboardBookingService.getOutstandingTrips(null, $routeParams.bookingId).then(function(trips) {
        const trip = trips && trips.length > 0 ? trips[0] : null;
        cm.hasLinkedBookings = trip.Bookings.length > 1;
        const bookingInfo = cm.hasLinkedBookings ? _.find(trip.Bookings, b => b.BookingId === cm.bookingId) : trip.Bookings.length > 0 ? trip.Bookings[0] : null;
        _processDeliveryAddress(bookingInfo.Type);

        cm.bk = bookingInfo;
        cm.leadPassenegr = { FirstName: bookingInfo.LeadPassengerFirstName, LastName: bookingInfo.LeadPassengerLastName };
    });

    function cancelContactChange() {
        $location.path(`dashboard/bookings/reference/${cm.bookingId}`);
    }
}
})();
